<bp-generic-dialog (closePressed)="closeDialog()">
  <div class="idenfy-iframe-dialog-content">
    <iframe #iFrame id="iframe" allowfullscreen [src]="src" style="width: 100%; height: 100%" allow="camera"></iframe>
  </div>
</bp-generic-dialog>
